import React from 'react';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { IRegulation } from '../../contracts/amendment.contract';
import { ICriteria } from '../../contracts/criteria.contract';

interface DropdownMenuProps {
    regulations: IRegulation[];
    filters: ICriteria;
    vesselNames?: string[];
    documentType: string;
    printMode: string;
    setPrintMode: (mode: string) => void;
}

const DropdownMenu = ({ regulations, filters, vesselNames, documentType, printMode, setPrintMode }: DropdownMenuProps) => {
    const handleAction = (action: string) => {
        setPrintMode(action);
    };

    return (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button variant="contained" startIcon={<AutoStoriesIcon />} onClick={() => handleAction('view')}>
                View PDF
            </Button>
            <Button variant="contained" startIcon={<PrintIcon />} onClick={() => handleAction('print')}>
                Print PDF
            </Button>
        </div>
    );
};

export default DropdownMenu;
